(function () {
  'use strict';
  const MILES_CONSTANT = 1.60934;

  class MeasurementUnitConverterService {

    constructor() { }

    getDateTimeFormat(dateTimeFormat) {
      return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy HH:mm:ss' : 'MM/dd/yy HH:mm:ss';
    }

    getDateFormat(dateTimeFormat) {
      return dateTimeFormat === 'BRITISH' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
    }

    getFormattedDateTimeWithTwoDigitYear(dateTimeFormat) {
      return dateTimeFormat === 'BRITISH' ? 'dd/MM/yy' : 'MM/dd/yy';
    }

    getDistanceUnit(distanceMeasurement) {
      return distanceMeasurement === 'KM' ? 'Km' : 'mi';
    }

    getSpeedUnit(speedMeasurement) {
      return speedMeasurement === 'KM' ? 'Km/h' : 'mph';
    }

    getFuelUnit(fuelMeasurement) {
      return fuelMeasurement === 'LITERS' ? 'L' : 'gal';
    }

    getFuelEfficiencyUnit(fuelMeasurement) {
      return fuelMeasurement === 'LITERS' ? 'Km/L' : 'mpg';
    }

    getEnergyEfficiencyUnit(distanceMeasurement) {
      return distanceMeasurement === 'KM' ? 'Km/kWh' : 'mi/kWh';
    }

    getKmhToMph(kmh) {
      return Math.round(kmh / MILES_CONSTANT);
    }

    getMphToKmh(miles) {
      return (miles * MILES_CONSTANT).toFixed(0);
    }
}

  angular
    .module('ModuleMeasurementUnitConverter', [])
    .service('MeasurementUnitConverterService', MeasurementUnitConverterService);
}());
